<template>
  <div style="background-color: #f8f8f8;width:100%">
    <section>
      <header-generic></header-generic>
    </section>
    <section>
      <b-container>
        <b-row>
          <b-col
            cols="12"
            sm="12"
            md="12"
            lg="5"
            class="bg-white section__border-radius"
          >
            <b-row>
              <b-col cols="6" class="section__filter_border">
                <label class="m-0 text-small" for="">Sucursal</label>
                <combo-store
                  v-model="storeCode"
                  isComboSelected
                  class="border-none"
                ></combo-store>
              </b-col>
              <b-col cols="6">
                <label class="m-0 text-small" for="">Nota de Venta</label>
                <b-form-input
                  v-on:keyup.enter="searchByNv"
                  class="border-none section__filter-small grey-input"
                  v-model.trim="filter.value"
                  placeholder="Ingresa una NV"
                ></b-form-input>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="2" xs="12" sm="12" md="12" lg="2">
            <b-button @click="searchByNv" class="rounded-button border-none">
              <font-awesome-icon icon="search" />
            </b-button>
          </b-col>
          <b-col
            cols="12"
            sm="12"
            md="12"
            lg="5"
            :class="'float-right main__section_title_color '+showCambiarFlujo"
            
          >
            <b-button
              :to="{ name: 'CreacionOs' }"
              class="section__button_trans border-none"
            >
              <span> <font-awesome-icon icon="sync-alt" /> </span> Cambiar flujo
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <template v-if="!Object.keys(dataClientNv).length">
      <section class="margin-two-top">
        <b-container>
          <b-row>
            <b-col
              cols="12"
              class="bg-white section__border-radius padding-all-fifty"
            >
              <p class="text-medium color-black font-weight-bold">
                Datos del cliente
              </p>
              <span>
                Ingresa una Nota de Venta en el buscador para obtener
                información
              </span>
            </b-col>
          </b-row>
        </b-container>
      </section>
      <section class="margin-two-top">
        <b-container>
          <b-row>
            <b-col
              cols="12"
              class="bg-white section__border-radius padding-all-fifty"
            >
              <p class="text-medium color-black font-weight-bold">
                Datos del servicio
              </p>
              <span>
                Ingresa una Nota de Venta en el buscador para obtener
                información
              </span>
            </b-col>
          </b-row>
        </b-container>
      </section>
    </template>
    <template v-else>
      <section>
        <b-container class="padding-lr-none">
          <b-row>
            <b-col cols="12" class="padding-three-tb">
              <h5 class="title__name text-large">
                Resultado Datos del cliente
              </h5>
            </b-col>
          </b-row>
        </b-container>
      </section>
      <section>
        <b-container class="bg-white padding-ten-all">
          <b-row>
            <b-col cols="12" md="4" lg="4">
              <label class="text-medium color-ligth-gray"
                >Nombre Completo</label
              >
              <span>
                {{
                  fullName
                }}
              </span>
            </b-col>
            <b-col cols="12" md="4" lg="4">
              <label class="text-medium color-ligth-gray"
                >Documento de identidad</label
              >
              <span>
                {{ dataClientNv.identityDocument }}
              </span>
            </b-col>
            <b-col cols="12" md="4" lg="4">
              <label class="text-medium color-ligth-gray">Teléfono Principal</label>
              <span v-if="selectedPhone"> {{ selectedPhone.contact }}</span>
              <b-button
                class="btn-rounded-orange border-none"
                v-b-modal.modal-phone
              >
                EDITAR</b-button
              >
              <!-- <b-modal
                size="lg"
                hide-footer
                class="modal-tit"
                id="modal-phone"
                title="Registro de teléfonos"
              >
                <MantenedorTelefono />
              </b-modal> -->
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="4" lg="4">
              <label class="text-medium color-ligth-gray"
                >Teléfono Secundario</label
              >
              <span v-if="selectedPhoneSec">
                {{ selectedPhoneSec.contact }}</span
              >
              <b-button
                class="btn-rounded-orange border-none"
                v-b-modal.modal-phone-secondary
              >
                EDITAR
              </b-button>
            </b-col>
            <b-col cols="12" md="4" lg="4">
              <label class="text-medium display-block color-ligth-gray"
                >Correo</label
              >
              <span v-if="selectedEmail"> {{ selectedEmail.contact }}</span>
              <b-button
                class="btn-rounded-orange border-none"
                v-b-modal.modal-email
              >
                EDITAR
              </b-button>
            </b-col>
            <b-col cols="12" md="4" lg="4">
              <label class="text-medium color-ligth-gray">Departamento</label>
              <span v-if="selectedDirection"
                >{{ selectedDirection.department }}
              </span>
            </b-col>
          </b-row>
          <b-row>
           <b-col cols="12" md="4" lg="4">
              <label class="text-medium color-ligth-gray">Provincia</label>
              <span class="padding-four-top" v-if="selectedDirection"
                >{{ selectedDirection.province }}
              </span>
            </b-col>
            <b-col cols="12" md="4" lg="4">
              <label class="text-medium color-ligth-gray">Distrito </label>
              <span class="padding-four-top" v-if="selectedDirection"
                >{{ selectedDirection.district }}
              </span>
            </b-col>
            <b-col cols="12" md="4" lg="4">
              <label class="text-medium color-ligth-gray">Dirección </label>

              <span class="padding-four-top" v-if="selectedDirection"
                >{{ selectedDirection.street }}
                {{ selectedDirection.number }}</span
              >
              <b-button
                class="btn-rounded-orange border-none"
                v-b-modal.modal-dir
              >
                EDITAR
              </b-button>
            </b-col>
          </b-row>
          
          <b-row>
            <b-col cols="12" md="4" lg="4">
              <label class="text-medium color-ligth-gray">Referencia</label>
              <span class="padding-four-top" v-if="selectedDirection"
                >{{ selectedDirection.reference }}
              </span>
            </b-col>
            <b-col cols="2" md="4">
              <label class="text-medium color-ligth-gray" for="input-small">
                Dep./Int./Lt.
              </label>
              <span class="padding-four-top" v-if="selectedDirection">
                {{ selectedDirection.numDepartament }}
              </span>
            </b-col>
            <b-col cols="2" md="4">
              <label class="text-medium color-ligth-gray" for="input-small">
                Nro./Mz./Bloq.
              </label>
              <span class="padding-four-top" v-if="selectedDirection">
                {{ selectedDirection.numberAdress }}
              </span>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="2" md="4">
              <label class="text-medium color-ligth-gray" for="input-small">
                Piso
              </label>
              <span class="padding-four-top" v-if="selectedDirection">
                {{ selectedDirection.numFloor }}
              </span>
            </b-col>
          </b-row>
        </b-container>
      </section>
      <template v-if="dataNV.length">
        <section>
          <b-container>
            <b-row>
              <b-col cols="12" class="padding-three-tb padding-lr-none">
                <h5 class="title__name text-large">
                  Resultado Datos del servicio
                </h5>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                cols="12"
                class="padding-three-tb bg-white padding-ten-all"
              >
                <table-details
                  :dataNV="dataNV"
                  @rowDetailelected="setSelectedRow"
                  @deleteRow="deleteSelectedRow"
                >
                </table-details>
              </b-col>
            </b-row>
          </b-container>
        </section>
        <section class="padding-two-top" v-show="isSelectedRow">
          <b-container>
            <b-row>
              <detail-seller-note
                v-for="(data, index) in dataNV"
                v-bind:index="index"
                v-bind:key="index"
                :isSelected.sync="data.isSelected"
                :descriptionSkuProduct.sync="data.descriptionSkuProduct"
                :descriptionSku.sync="data.descriptionSku"
                :quantity.sync="data.quantity"
                :maxLimit="data.maxLimit"
                :turn.sync="data.turn"
                :skuProduct.sync="data.skuProduct"
                :skuService.sync="data.skuService"
                :estimatedDate.sync="data.estimatedDate"
                :restrictedDays="restrictedDays"
                :providerId.sync="data.providerId"
                :providerName.sync="data.providerName"
                :providerObservation.sync="data.providerObservation"
                :storeCode="storeCode"
                :optionsProvider.sync="optionsProvider"
                :showModalProvider.sync="showModalProvider"
                :isBusy.sync="isBusy"
                :indexModal="index"
                :rowIndex.sync="rowIndex"
                :request.sync="request"
                :messageEstimation.sync="messageEstimation"
                :isBusyM.sync="isBusyM"
              >
              </detail-seller-note>
            </b-row>
          </b-container>
        </section>
      </template>
      <section class="margin-two-top">
        <observation-input v-model="clientObservation"></observation-input>
      </section>
      <section class="margin-two-tb">
        <b-container class="padding-lr-none">
        <b-row v-if="isVisibleMsgError">
            <b-col cols="12">
                <ul>
                  <li v-show="isVisibleMsgPhone">Ingresa el teléfono del cliente</li>
                  <li v-show="isVisibleMsgEmail">Ingresa el correo del cliente</li>
                  <li v-show="isVisibleMsgDirection">Ingresa la dirección del cliente</li>

                </ul> 
            </b-col>
          </b-row> 
          <b-row>
            <b-col cols="12" class="text-center">
              <b-button
                :disabled="isDisabled"
                class="border-none btn-rounded-orange"
                @click="showConfirmBox"
                >CREAR OS</b-button
              >
            </b-col>
          </b-row>
        </b-container>
      </section>
    </template>
    <div>
      <b-modal
        @hidden="onHiddenModal"
        no-close-on-esc
        no-close-on-backdrop
        hide-footer
        id="modal-os"
        centered
        ok-only
        content-class="text-center"
      >
        <ModalOS>
          <template slot="body">
            <template v-if="!hasError">
              <p class="my-4 text-center">
                {{ messageOS }}
              </p>
              <p class="my-4 text-center">Orden de servicio N°: {{ osId }}</p>
              <b-button class="bg-orange" @click="reset"> OK </b-button>
            </template>
            <template v-else>
              <p>{{ messageOS }}</p>
              <b-button class="bg-orange" @click="resetError"> OK </b-button>
            </template>
          </template>
        </ModalOS>
      </b-modal>
      <!-- <b-modal :id="infoModal.id" hide-footer title="Seleccionar SKU">
        <modal-sku-products
          :isBusy="isBusy"
          :listSkus="listSkusProducts"
          @rowSkuSelected="setSelectedProduct"
        >
        </modal-sku-products>
      </b-modal>-->
      <b-modal
        v-model="showModalProvider"
        @hidden="onHidden"
        hide-footer
        id="info-modal-provider"
        title="Seleccionar Proveedor"
      >
        <modal-provider
          :messageEstimation="messageEstimation"
          :isBusy="isBusyM"
          :optionsProvider="optionsProvider"
          @rowProviderSelected="onRowSelectedProvider"
        >
        </modal-provider>
      </b-modal>
      <b-modal
        size="lg"
        hide-footer
        class="modal-tit"
        id="modal-phone-secondary"
        title="Registro de teléfonos"
      >
        <mantenedor-telefono
          :id="dataClientNv.id"
          :phones="dataClientNv.phones"
          :selectedPhone.sync="selectedPhoneSec"
          @update="addNewPhoneSec"
        >
        </mantenedor-telefono>
      </b-modal>
      <b-modal
        size="md"
        hide-footer
        class="modal-tit"
        id="modal-phone"
        title="Registro de teléfonos"
      >
        <mantenedor-telefono
          :id="dataClientNv.id"
          :phones="dataClientNv.phones"
          :selectedPhone.sync="selectedPhone"
          @update="addNewPhone"
        >
        </mantenedor-telefono>
      </b-modal>
      <b-modal
        size="lg"
        hide-footer
        class="modal-tit"
        id="modal-email"
        title="Registro de correos"
      >
        <mantenedor-correo
          :id="dataClientNv.id"
          :mails="dataClientNv.mails"
          :selectedEmail.sync="selectedEmail"
          @update="addNewMail"
        >
        </mantenedor-correo>
      </b-modal>
      <b-modal
        size="xl"
        hide-footer
        class="modal-tit"
        id="modal-dir"
        title="Registro de direcciones"
      >
        <modal-direcciones
          :id="dataClientNv.id"
          :directions="dataClientNv.directions"
          :selectedDirection.sync="selectedDirection"
          @update="addNewDirection"
        >
        </modal-direcciones>
      </b-modal>
    </div>
  </div>
</template>
<script>
import ModalOS from "../../components/ModalOS";
import moment from "moment";
import axios from "axios";
import { mapState } from "vuex";
import ModalProvider from "../../components/CrearOS/ModalProvider.vue";
import HeaderGeneric from "../../components/CrearOS/HeaderGeneric.vue";
import ComboStore from "../../components/ComboStore.vue";
import MantenedorCorreo from "../../components/CrearOS/MantenedorCorreo.vue";
import ModalDirecciones from "../../components/CrearOS/ModalDirecciones.vue";
import MantenedorTelefono from "../../components/CrearOS/MantenedorTelefono";
import ObservationInput from "../../components/CrearOsManual/ObservationInput.vue";
import DetailSellerNote from "../../components/NotaVenta/DetailSellerNote.vue";
import TableDetails from "../../components/CrearOS/TableDetails.vue";
import store from "@/store";
export default {
  name: "NotaVenta",
  data() {
    return {
      
      messageEstimation:"",
      showModalProvider: false,
      isSelectedRow: false,
      actualDate: moment().add(1, "days").format("YYYY-MM-DD"),
      optionsShip: [
        { value: null, text: "Seleccione una opción" },
        { value: "MORNING", text: "Mañana" },
        { value: "AFTERNOON", text: "Tarde" },
        { value: "ALL_DAY", text: "Durante el día" },
      ],
      selectMode: "single",
      rowIndex: 0,
      isBusy: false,
      hasError: false,
      messageOS: "",
      boxOne: false,
      optionStores: [],
      clientObservation: "",
      filter: {
        value: "",
      },
      options: [{ value: null, text: "Please select an option" }],
      date: moment().format("DD-MM-YYYY"),
      dataNV: [],
      infoModal: {
        id: "info-modal",
        title: "",
        index: 0,
      },
      infoModalProvider: {
        id: "info-modal-provider",
        title: "",
        index: 0,
      },
      fieldsProvider: [
        { key: "selected", label: " " },
        { key: "providerName", label: "Proveedor" },
        { key: "capacity", label: "Capacidad" },
      ],
      optionsProvider: [],
      listSkusProducts: [],
      restrictedDays: [],
      blockedSkus: [
        { sku: "127798" },
        { sku: "127802" },
        { sku: "1586391" },
        { sku: "25956" },
        { sku: "25968" },
        { sku: "26289" },
        { sku: "26290" },
        { sku: "26575" },
        { sku: "32469" },
      ],
      storeCode: null,
      selectedPhone: null,
      selectedPhoneSec: null,
      selectedEmail: null,
      selectedDirection: null,
      dataClientNv: {},
      osId: null,
      request: null,
      isBusyM: false,
    };
  },
  props:{
    idProject:{
      type: Number
    },
    showCambiarFlujo: {
      type: String
    }
  },
  components: {
    ModalOS,
    ModalProvider,
    HeaderGeneric,
    ComboStore,
    ModalDirecciones,
    MantenedorCorreo,
    MantenedorTelefono,
    ObservationInput,
    DetailSellerNote,
    TableDetails,
  },
  computed: {
    ...mapState("module", ["store", "username","token"]),
    fullName() {
     let name= this.dataClientNv.names? this.dataClientNv.names:''
     let lastName= this.dataClientNv.lastName? this.dataClientNv.lastName:'';
     let motherLastName= this.dataClientNv.motherLastName? this.dataClientNv.motherLastName:''
      
     return `${name} ${lastName} ${motherLastName}`
    },
    isDisabled() {
      if (this.dataNV.length == 0||!this.selectedPhone||!this.selectedDirection||!this.selectedEmail) return true;
      return false;
    },
    isVisibleMsgError(){
      if ((!this.selectedPhone||!this.selectedDirection||!this.selectedEmail)) return true;
      return false;
    },
    isVisibleMsgPhone(){
      if ((!this.selectedPhone)) return true;
      return false
    },
    isVisibleMsgEmail(){
      if ((!this.selectedEmail)) return true;
      return false
    },
    isVisibleMsgDirection(){
      if ((!this.selectedDirection)) return true;
      return false
    }
  },
  beforeRouteEnter(to, from, next) {
    let menu = store.getters["module/optionsMenu"];
    let perfil = store.getters["module/profile"];
    let authProvider = menu.some((m) => m.id ==1);
    if (authProvider&&perfil!=="PROVEEDOR") next();
    else next({ name: "BlockedPage" });
  },
  mounted() {
    this.getRestrictedDays();
  },
  methods: {
    async updateProject(valOs){
      try{
        if(this.idProject==null||this.idProject=== undefined) return;
      let response = await axios.put(
          process.env.VUE_APP_PROJECT_BASE + "/" + this.idProject,
          {
            id: this.idProject,
            id_os_instalacion: valOs,
            cotizaciones:[]
          }, // the data to post
          {
            headers: {
              "Content-type": "application/json",
            },
          }
        );
        console.log(response);
        let values = { variant: "success", msg: "Se actualizó exitosamente !" };
        await this.getStatesAndSubStates();
        this.clearValues()
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
      } catch (error) {
        console.log(error);
        let values = { variant: "danger", msg: error.response.data.message };
        this.$store.commit("setShowAlert", true);
        this.$store.commit("SET_ERROR_MSG", values);
      } finally {
        setTimeout(() => this.$store.commit("setShowAlert", false), 3000);
       
      }
    },
    addNewPhoneSec(phone) {
      this.dataClientNv.phones.push(phone);
      this.selectedPhoneSec = phone;
      this.$bvModal.hide("modal-phone-secondary");
    },
    onHiddenModal() {
      if (this.hasError) this.hasError = false
      
    },
    addNewPhone(phone) {
      this.dataClientNv.phones.push(phone);
      this.selectedPhone = phone;
      this.$bvModal.hide("modal-phone");
    },
    addNewMail(email) {
      this.dataClientNv.mails.push(email);
      this.selectedEmail = email;
      this.$bvModal.hide("modal-email");
    },
    addNewDirection(direction) {
      this.dataClientNv.directions.push(direction);
      this.selectedDirection = direction;
      this.$bvModal.hide("modal-dir");
    },
    resetError() {
      this.messageOS = "";
      this.$bvModal.hide("modal-os");
    },

    async getRestrictedDays() {
      try {
        let response = await axios.get(
          process.env.VUE_APP_RESTRICTIONS_BASE +
            "/restricted_days/dates?dateFormat=yyyy-MM-dd"
        );
        this.restrictedDays = response.data;
      } catch (error) {
        console.log(error);
      }
    },
    selectRowData(item, index) {
      this.dataNV[index].isSelected = true;
    },
    setSelectedRow(selected) {
      this.dataNV[selected].isSelected = true;
      this.infoModal.index = selected;
      this.isSelectedRow = true;
    },

    reset() {
      this.$bvModal.hide("modal-os");
      this.$router.push({ name: "CreacionOs" });
    },
    showConfirmBox() {
      this.boxOne = "";
      this.$bvModal
        .msgBoxConfirm("¿Desea guardar los cambios en el sistema?", {
          title: "",
          size: "sm",
          buttonSize: "sm",
          okVariant: "orange",
          okTitle: "Guardar cambios",
          cancelTitle: "Cancelar",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
          contentClass: "text-center",
        })
        .then((value) => {
          this.boxOne = value;
          if (this.boxOne) {
            this.createOs();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    checkIfProducExist(item) {
      if (item && item.products.length) return true;
      return false;
    },
    resetValues() {
      if (this.messageOS.length) this.messageOS = "";
      this.clientObservation = "";
      if (this.dataNV.length) this.dataNV = [];
      this.hasError = false;
      this.dataClientNv = {};
      if (this.selectedPhone) this.selectedPhone = null;
      this.selectedPhoneSec = null;
      if (this.selectedEmail) this.selectedEmail = null;
      if (this.selectedDirection) this.selectedDirection = null;
      if (this.osId) this.osId = null;
    },
    async searchByNv() {
      try {
        this.$store.commit("SET_LOADING", true);
        this.resetValues();
        let response = await axios.get(
          process.env.VUE_APP_SELLERNOTE_REF +
            "?sellerNote=" +
            this.filter.value,
            {
              headers: {
                  "Content-type": "application/json",
                  "Authorization": "Bearer "+ this.token
                }
            }
        );
        if (
          response.data.used ||
          response.data.status === "CANCELLED_NOT_PAYED"
        ) {
          if (response.data.used)
            this.messageOS =
              "La N.V " + this.filter.value + " ya ha sido utilizada";
          else if (response.data.status === "CANCELLED_NOT_PAYED")
            this.messageOS = "La N.V se encuentra cancelada";
          else this.messageOS = "Hubo un error";
          this.hasError = true;
          this.$bvModal.show("modal-os");
          return;
        } 
        this.storeCode = response.data.storeCode;
        let filterData = response.data.details.filter(
          (item) =>
            !!item.serviceSku &&
            !this.blockedSkus.find(({ sku }) => item.serviceSku === sku)
        );
        const { client } = response.data;

        const data = filterData.map((row) => {
          return {
            descriptionSku: row.serviceSku ? row.description : "",
            skuService: row.serviceSku ? row.serviceSku : "",
            skuProduct: "",
            descriptionSkuProduct: "",
            quantity: row.quantity,
            maxLimit: row.quantity,
            estimatedDate: "",
            turn: null,
            providerId: null,
            providerName: "",
            state: this.translateState(response.data.status),
            providerObservation: "",
            isSaved: false,
            isSelected: false,
          };
        });
        this.dataNV = data;

        this.dataClientNv = client;
        this.dataClientNv.sellerNoteNumber = response.data.sellerNoteNumber;
        this.selectedPhone = client.phones?.length ? client.phones[0] : null;
        this.selectedEmail = client.mails?.length ? client.mails[0] : null;
        this.selectedDirection = client.directions.length
          ? client.directions[0]
          : null;
      } catch (error) {
        this.messageOS = error.response.data.message;
        this.$bvModal.show("modal-os");
        this.hasError = true;
      } finally {
        this.$store.commit("SET_LOADING", false);
      }
    },
    translateState(value) {
      switch (value) {
        case "PAYMENT_PENDING":
          return "PENDIENTE_PAGO";
        case "PAYED":
          return "INGRESADA";
        case "CANCELLED_NOT_PAYED":
          return "CANCELADO";
        default:
          return "PENDIENTE_PAGO";
      }
    },
    async createOs() {
      try {
        const typeOs = this.$route.params.tipo?this.$route.params.tipo:null;
        let idOsOriginVtec=null;
        let idOsOriginVins=null;
        console.log(this.$route.params.tipo,this.$route.params.id)
        console.log(typeOs)
        if(typeOs=='VI'){
          idOsOriginVins=this.$route.params.id?this.$route.params.id:null;
        }
        else if(typeOs=='VTEC'){
          idOsOriginVtec=this.$route.params.id?this.$route.params.id:null;
          console.log(idOsOriginVtec)
        }
        this.$store.commit("SET_LOADING", true);

        const format = this.dataNV.map((row) => {
          return {
            estimatedDate: row.estimatedDate,
            referenceDate: row.estimatedDate,
            providerId: row.providerId,
            quantity: row.quantity,
            serviceSku: row.skuService.trim(),
            referenceSku: row.skuProduct.trim(),
            state: row.state,
            turn: row.turn,
            sellerNote: this.dataClientNv.sellerNoteNumber,
            providerObservation: row.providerObservation,
            idOsOriginVtec:idOsOriginVtec,
            idOsOriginVins:idOsOriginVins
          };
        });
        let contactIdSec=this.selectedPhoneSec?this.selectedPhoneSec.id:null;
        let response = await axios.post(
          process.env.VUE_APP_ORDER_BUSINESS_BASE + "/orders",
          {
            clientId: this.dataClientNv.id,
            directionId: this.selectedDirection.id,
            emailId: this.selectedEmail.id,
            contactId: this.selectedPhone.id,
            contactIdSecondary:contactIdSec,
            store: this.storeCode,
            observation: this.clientObservation,
            registerUser: this.username,
            origin:"TIENDA",
            details: format,
          },
          {
            headers: {
              "Content-type": "application/json",
            },
          }
        );
        let pendientePago = response.data.details.some(
          (data) => data.state == "PENDIENTE_PAGO"
        );
        this.updateProject(response.data.id)
        if (pendientePago) {
          this.osId = response.data.id;
          this.messageOS =
            "La OS se encuentra encuentra en estado pendiente de pago";
          this.$bvModal.show("modal-os");
        } else {
          this.$router.push({ path: `/print-os/${response.data.sequence}` });
        }
        console.log(response);
      } catch (error) {
        if (error.response) {
          this.messageOS = error.response.data.message;
        } else {
          this.messageOS = error.message;
        }
        console.log(error.message);

        this.$bvModal.show("modal-os");
        this.hasError = true;
      } finally {
        this.$store.commit("SET_LOADING", false);
      }
    },

    onRowSelectedProvider(selected) {
      this.dataNV[this.rowIndex].providerName = selected.providerName;
      this.dataNV[this.rowIndex].providerId = selected.providerId;
      this.showModalProvider = false;
    },
    deleteSelectedRow(selected) {
      this.dataNV.splice(selected, 1);
    },
    onHidden() {
      this.optionsProvider=[];
      this.messageEstimation="";
      if (!this.isBusyM) return;
      this.request.cancel();
    },
  },
};
</script>
<style scoped>
.hidden{visibility: hidden;}
.input-group-addon:first-child {
  border-left-width: 1px;
}
.input-group-addon:last-child {
  border-right-width: 1px;
}
.input-group-addon-orange {
  border-right-width: 1px;
  border-right: 1px solid orange;
}
::v-deep #modal-os___BV_modal_header_ {
  display: none;
}
::v-deep .b-table thead th {
  font-weight: 600 !important;
  border: none !important;
  font-size: 14px;
}
::v-deep .table td {
  color: black;
  font-size: 14px;
  border-top: 1px solid #ff8000 !important;
}

::v-deep .table-striped tbody tr:nth-of-type(odd) {
  background-color: transparent;
}
::v-deep .table tr:first-child td {
  border-top: 1px solid transparent !important;
}
.bg-grey.form-control:disabled {
  background: white !important;
  border-bottom: none !important;
}
.custom-select:disabled {
  background: white !important;
  border-bottom: none !important;
  color: #000000 !important;
}
.hidden-disabled.btn:disabled {
  display: none;
}
.bg-grey.form-control:read-only {
  background: white !important;
  border-bottom: none !important;
}

.disable-input {
  pointer-events: none;
}
input.text-medium::placeholder {
  color: #000000 !important;
  font-size: 14px;
}
textarea::placeholder {
  color: #000000 !important;
  font-size: 14px;
}
.isHidden {
  display: none;
}
</style>